import { render } from "./RegisterStep3.vue?vue&type=template&id=1ee5d25e&scoped=true&lang=pug"
import script from "./RegisterStep3.vue?vue&type=script&lang=js"
export * from "./RegisterStep3.vue?vue&type=script&lang=js"

import "./RegisterStep3.vue?vue&type=style&index=0&id=1ee5d25e&scoped=true&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee5d25e"]])

export default __exports__